import { gql } from '@apollo/client';
const REMOVE_TENANT_SEASON = gql `
  mutation RemoveTenantSeason($seasonId: ID!) {
    removeSeason(seasonId: $seasonId) {
      removed
    }
  }
`;
export default REMOVE_TENANT_SEASON;
